import addressComp from "../address.vue";
import { cpfCnpj, phone } from "../../../filters/string";
import { brToAm } from "../../../filters/date";
import Account from "../../../services/account";
import Auth from "../../../services/auth";
import { contract } from "./objects";
import Contracts from "../../../services/contracts";
import MessageDialog from "../../../components/message-dialog.vue";

export default {
  props: ["user", "address", "blockTaxIdNumber"],
  data() {
    return {
      token: null,
      step: 0,
      validacao: undefined,
      lastNetrimQuery: null,
    };
  },
  mounted() {
    // this.user.accountAuthentication.login = "";
    this.checkCpfValidationPermission();
    this.sincronizarCamposMascarados();
  },

  computed: {
    tel: {
      get() {
        return this.getTelFormated();
      },
      set(newValue) {
        this.setTelFormated(newValue);
      },
    },
    cel: {
      get() {
        return this.getCelFormated();
      },
      set(newValue) {
        this.setCelFormated(newValue);
      },
    },
  },
  methods: {
    sincronizarCamposMascarados() {
      const campos = [
        [this.$refs.taxIdNumber, () => this.user, "taxIdNumberFormatted"],
        [this.$refs.birthDate, () => this.user && this.user.person, "birthDateBR"],
      ];

      campos.forEach(([el, obterAlvo, propriedade]) => {
        if (!el) return;

        const sincronizar = () => {
          const alvo = obterAlvo();
          if (alvo && alvo[propriedade] !== el.value) {
            this.$set(alvo, propriedade, el.value);
          }
        };

        const aoEditar = () => {
          sincronizar();
          setTimeout(sincronizar, 0);
        };

        el.addEventListener("input", aoEditar);
        el.addEventListener("keyup", aoEditar);
      });
    },

    async checkCpfValidationPermission() {
      const resp = await Auth.checkCpfValidationPermission();
      this.token = resp.token;
    },
    ValidacaoNetrim: _.debounce(async function () {
      var cpf = this.user.taxIdNumberFormatted.replaceAll(/[^0-9]/g, "");
      var dataNascimento = this.user.person.birthDateBR
        ? this.user.person.birthDateBR.replaceAll("/", "-")
        : null;

      // A data so pode ir para a Netrin completa: a mascara "DD/MM/AAAA" tem 10
      // caracteres. Sem esta guarda, uma pausa no meio da digitacao consulta o
      // bureau com data parcial (ex.: "01-0"), a recusa cai no ramo de erro e
      // limpa CPF, data e nome do formulario -- Bug 406.
      var dataCompleta = !!dataNascimento && dataNascimento.length === 10;

      if (cpf.length >= 11 && dataCompleta && this.user.person.fullName) {
        const queryKey = `${cpf}_${dataNascimento}`;
        if (this.lastNetrimQuery === queryKey) return;
        this.lastNetrimQuery = queryKey;

        try {
          await this.checkCpfValidationPermission();
        } catch (e) {
        }
        Contracts.ConsultaNetrimLog(cpf, dataNascimento, this.token).then(
          (resp) => {
            //Validacao Gunfire
            if (resp.consulta.length == 0) {
              this.validacao = true;
            }
            //Verificação código de retorno API Netrim
            else if (resp.consulta[0].exception == 0) {
              this.validacao = true;
            } else if (resp.consulta[0].exception == 2) {
              this.validacao = false;
              this.user.taxIdNumberFormatted = "";
              this.user.person.birthDateBR = "";
              this.user.person.fullName = "";
              MessageDialog.show({
                title: "Oops! Alguma coisa deu errada!",
                message:
                  "Não foi possível validar seu CPF no momento. Por favor, entre em contato com nossa Central de Relacionamento, através dos números 4000 2901 (Capitais e regiões metropolitanas) e 0800 777 1022 (Demais localidades).",
                headerClass: "modal-danger",
              });
            } else {
              this.validacao = false;
              this.user.taxIdNumberFormatted = "";
              this.user.person.birthDateBR = "";
              this.user.person.fullName = "";

              MessageDialog.show({
                title: "Oops! Alguma coisa deu errada!",
                message:
                  "Não podemos prosseguir com o seu cadastro. Para maiores informações, consulte seu CPF na página da Secretaria da Receita Federal, ",
                headerClass: "modal-danger",
                type: "BLANK",
                txtBlank: "clicando aqui!",
                urlBlank:
                  "https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp",
                colorTxtBlank: "#0000FF",
              });
            }
          },
        ).catch((err) => {
          console.warn("Falha ao validar CPF na Netrin:", err);
        });
      }
    }, 500),
    correctCursor2(a) {
      if (!window.document.mobile) return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },
    getTelType(type) {
      let tels = _.filter(
        this.user.telephones.telephone,
        (o) => o.type == type,
      );
      if (tels && tels.length > 0) return tels[0];

      var t = { ddd: "", numberPhone: "", type: type };
      this.user.telephones.telephone.push(t);

      return t;
    },
    getCelFormated(obj) {
      return phone(this.user.dddCellphone + this.user.nroCellphone);
    },
    setCelFormated(value) {
      let t = value.replace(/[^0-9]/g, "");
      this.user.dddCellphone = t.substring(0, 2);
      this.user.nroCellphone = t.substring(2, 11);
    },
    getTelFormated(obj) {
      return phone(this.user.dddPhone + this.user.nroPhone);
    },
    setTelFormated(value, obj) {
      let t = value.replace(/[^0-9]/g, "");
      this.user.dddPhone = t.substring(0, 2);
      this.user.nroPhone = t.substring(2, 11);
    },

    validateAll() {
      let vm = this;
      return this.$validator
        .validateAll()
        .then((r) => {
          vm.user.person.fullName = vm.user.person.fullName.trim();
          let firstSpace =
            vm.user.person.fullName.indexOf(" ") ||
            vm.user.person.fullName.length;
          vm.user.person.name = vm.user.person.fullName.substring(
            0,
            firstSpace,
          );
          vm.user.person.lastName = vm.user.person.fullName.substring(
            firstSpace + 1,
            vm.user.person.fullName.length,
          );
          vm.user.person.birthDate = brToAm(vm.user.person.birthDateBR);
          vm.user.taxIdNumber = vm.user.taxIdNumberFormatted.replace(
            /[^0-9]/g,
            "",
          );
          vm.user.email2 = vm.user.accountAuthentication.login;

          return Account.accountExists({
            taxIdNumber: vm.user.taxIdNumber,
          }).then((r) => {
            if (!r) return Promise.reject("Erro");
          });
        })
        .then((r) => {
          return vm.$refs.addressMailing.$validator.validateAll();
        });
    },
  },

  components: { addressComp },
};



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/user-data.js